import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index.vue'
import Personnel from '../views/Personnel.vue'
import Login from '../views/Login.vue'
import Member from '../views/Member.vue'
import Version from '../views/Version.vue'
import Route from '../views/Route.vue'
import Plan from '../views/Plan.vue'
import Forgot from '../views/Forgot.vue'
import Place from '../views/Place.vue'
import RouteList from '../views/RouteList.vue'

Vue.use(Router)

export default new Router({
  routes: [
    // 首页-展示团队地点+地图
    {
      path: '/',
      name: 'index',
      component: Index
    },
    // 路线列表
    {
      path: '/route/list',
      name: 'route-list',
      component: RouteList
    },
    // 地点库列表模式
    {
      path: '/place',
      name: 'place',
      component: Place
    },
    // 团队业务员管理页面
    {
      path: '/personnel',
      name: 'personnel',
      component: Personnel
    },
    // 登录/注册页面
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // 会员购买
    {
      path: '/member',
      name: 'member',
      component: Member
    },
    // 版本更新
    {
      path: '/version',
      name: 'version',
      component: Version
    },
    // 路线详情地图
    {
      path: '/route/:id',
      name: 'route',
      component: Route
    },
    // 路线规划页面
    {
      path: '/plan',
      name: 'plan',
      component: Plan
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js